// Author Lin
// Date 2024-06-18 08:56:52

import * as model from "@/model/sithMes/inventory/SithMesInventoryDeliveryMaterialModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryDeliveryMaterial(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'partsFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'dn400Filter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'inspectionFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'orderFilter',
        filterInitializer: newFilter
    })
    .buildStore()
